import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import { Coberturas } from "./compModal/Coberturas";
import { FormaPrima } from "./compModal/FormaPrima";
import { Deducibles } from "./compModal/Deducibles";
import { Notas } from "./compModal/Notas";
import { Contratante } from "./Contratante";
import { Asegurados } from "./Asegurados";
import { DocsDigitalTabla } from "../../gen/siniestros/DocsDigitalTabla";
import { has_role } from "../../util/General";

export class Condiciones extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            item: {},
            hTabs: "ht1",
            coberturas: [],
            primas: [],
            clausulas: [],
            deducibles: [],
            exclusiones: [],
            notas: [],
            docdigital: [],
            docminio: [],
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    fetchData() {
        let docItem = this.props.poliza;
        this.getCoberturas(this.props.item.cdCompania, this.props.item.cdUbicacion);
        this.getFormaPrima(this.props.item.cdCompania, this.props.item.cdUbicacion);
        this.getDeducibles(this.props.item.cdCompania, this.props.item.cdUbicacion);
        this.getExclusiones(this.props.item.cdCompania, this.props.item.cdUbicacion);
        this.getNotas(this.props.item.cdRamoCotizacion);
        this.getClausulas(this.props.item.cdCompania, this.props.item.cdUbicacion);
        this.getDocDigital(
            docItem.cdCliente,
            docItem.cdCompania,
            docItem.cdCotizacion,
            docItem.numCotizacion,
            docItem.poliza
        );
    }

    getDocDigital = (cdcliente, cdcompania, cdcotizacion, numCotizacion, cdPoliza) => {
        axios
            .get(routes.apiGen + "/docs", {
                params: {
                    tipo: "poliza",
                    cdCliente: cdcliente,
                    cdCompania: cdcompania,
                    cdCotizacion: cdcotizacion,
                    numCotizacion: numCotizacion,
                    cdPoliza: cdPoliza,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    getCoberturas = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/coberturas", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let cobs = resp.data;
                cobs = Object.entries(cobs);
                this.setState({ coberturas: cobs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getFormaPrima = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/formaPrima", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let primas = resp.data;
                this.setState({ primas: primas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDeducibles = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/deducibles", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let deducibles = resp.data;
                this.setState({ deducibles: deducibles });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getExclusiones = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/exclusiones", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let exclusiones = resp.data;
                this.setState({ exclusiones: exclusiones });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getNotas = cdRamoCoti => {
        axios
            .get(routes.api + "/notas", {
                params: {
                    cdRamosCotizacion: cdRamoCoti,
                },
            })
            .then(resp => {
                let notas = resp.data.sort((a1, a2) => a1.cdAclaratorio - a2.cdAclaratorio);
                this.setState({ notas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getClausulas = (idComp, cdUbicacion) => {
        axios
            .get(routes.api + "/clausulas", {
                params: {
                    cdCompania: idComp,
                    cdUbicacion: cdUbicacion,
                },
            })
            .then(resp => {
                let notas = resp.data;
                this.setState({ clausulas: notas });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    onClose = () => {
        let docItem = this.props.poliza;
        this.getDocDigital(docItem.cdCliente, docItem.cdCompania, docItem.cdCotizacion, docItem.poliza);
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [], item: {} });
    };

    tabSelect = tab => {
        this.setState({ hTabs: tab });
    };

    render() {
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail" isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante poliza={this.props.poliza} item={this.props.item} />

                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={() => {
                                        this.closeModal();
                                    }}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Detalle Póliza</h5>
                            <Coberturas hTabs={this.state.hTabs} coberturas={this.state.coberturas} />
                            <div className="my-1" />
                            <Asegurados
                                hTabs={this.state.hTabs}
                                cdObjetoCotizacion={this.props.cdObjCotizacion}
                                cdCompania={this.props.item.cdCompania}
                                item={this.state.item}
                            />
                            <div className="my-1" />
                            <FormaPrima hTabs={this.state.hTabs} primas={this.state.primas} />
                            <div className="my-1" />
                            <Deducibles hTabs={this.state.hTabs} deducibles={this.state.deducibles} />
                            <div className="my-1" />
                            <Notas hTabs={this.state.hTabs} notas={this.state.notas} />
                            <div className="my-1" />
                            {(has_role(this.props.user, "ROLE_ADMIN") || has_role(this.props.user, "ROLE_BROKER")) && (
                                <DocsDigitalTabla
                                    hTabs={this.state.hTabs}
                                    docdigital={this.state.docdigital}
                                    tipo={"poliza"}
                                    dato={this.props.poliza}
                                    onClose={this.onClose}
                                />
                            )}
                            {/*<Clausulas hTabs={this.state.hTabs} clausulas={this.state.clausulas}/>*/}
                            {/*<div className="my-1"/>*/}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
